import React from 'react';
import ReactDOM from 'react-dom/client';
import CulturalComparison from './CulturalComparison';
import './index.css'; // uniquement si vous souhaitez styliser globalement

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CulturalComparison />
  </React.StrictMode>
);
